<template>

  <div class="h-full">
    <!-- Main Content -->
    <div class="flex gap-6 h-full p-6">
      <!-- Products Section (Left) -->
      <div class="flex-1 overflow-hidden">
  <!--<div class="table-view">
    <div class="header">
      <h2>Table Management</h2>
      <button @click="refreshTables" class="btn-refresh" :disabled="loading">
        {{ loading ? 'Loading...' : 'Refresh' }}
      </button>
    </div>-->

    <div class="tables-grid">
      <div
        v-for="table in tables"
        :key="table.id"
        :class="['table-container', `status-${table.status}`]"
        @click="selectTable(table)"
      >
        <div :class="['table-visual', getTableShape(table.capacity)]">
          <div
            v-for="chair in table.capacity"
            :key="chair"
            :class="['chair', `position-${chair}`]"
            :style="getChairPosition(chair, table.capacity)"
          >
            <div class="chair-icon"></div>
          </div>

          <div class="table-surface">
            <div class="table-number">{{ table.table_number }}</div>
            <div class="table-capacity">{{ table.capacity }} seats</div>
          </div>
        </div>

        <div :class="['status-badge', table.orders ? 'occupied' : 'available']">
          {{ table.orders ? 'occupied' : 'available' }}
        </div>
      </div>
    </div>
  </div>
  </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref, watch } from 'vue'
import { CashierDuty, PaymentType, PosStation, RestaurantTables, SalesRep } from '../../../../../types/models'
import { User } from '../../../../../types/auth';
import { posStore } from '../../../../../stores/posStore';
//import OrderSummary from '../components/OrderSummary.vue';

const pos = posStore();

const props = defineProps<{
  isFullscreen: boolean,
  payment_types: PaymentType[]
  delivery_staffs: User[]
  posStation: PosStation | undefined
  cashierDuty: CashierDuty | null
  salesReps: SalesRep[]
  restaurantTables: RestaurantTables[]
}>()


const emit = defineEmits(['table-selected', 'order-created'])

const tables = ref<RestaurantTables[]>([])

onMounted(() => {
    tables.value = props.posStation?.outlet?.tables || []
})


/*const orderCreated = (tables: RestaurantTables[]) => {
  emit("order-created", tables);
}

const handleNew = () => {

}*/


function selectTable(table: RestaurantTables) {
  pos.selectedTable = table;
  emit('table-selected', table)
}

function getTableShape(capacity: number): string {
  if (capacity === 2) return 'round'
  if (capacity === 4) return 'square'
  if (capacity === 6) return 'rectangle'
  if (capacity === 5) return 'octagon'
  return 'rectangle-large'
}

function getChairPosition(chairIndex: number, capacity: number) {
  const angle = ((chairIndex - 1) / capacity) * 360
  const radius = capacity === 2 ? 70 : capacity === 4 ? 80 : capacity === 6 ? 90 : 100

  const radians = (angle - 90) * (Math.PI / 180)
  const x = Math.cos(radians) * radius
  const y = Math.sin(radians) * radius

  return {
    transform: `translate(${x}px, ${y}px) rotate(${angle}deg)`
  }
}


watch(() => props.restaurantTables, () => {
  tables.value = props.restaurantTables || [];
});

</script>

<style scoped>
.table-view {
  padding: 2rem;
  background: #f9fafb;
  min-height: 100vh;
  overflow-y: auto;
  height: 100vh;
}

.tables-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 3rem;
  padding: 2rem;
  align-items: start;
}

.table-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
}

.table-container:hover {
  transform: scale(1.05);
}

.table-container.status-occupied {
  cursor: not-allowed;
  opacity: 0.7;
}

.table-container.status-occupied:hover {
  transform: scale(1);
}

.table-visual {
  position: relative;
  width: 200px;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.table-surface {
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #8b5cf6;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  z-index: 1;
  transition: all 0.3s;
}

.table-container.status-available .table-surface {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
}

.table-container.status-occupied .table-surface {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
}

.table-container.status-reserved .table-surface {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
}

.table-surface.round {
  width: 100px;
  height: 100px;
  border-radius: 50%;
}

.table-visual.round .table-surface {
  width: 90px;
  height: 90px;
  border-radius: 50%;
}

.table-visual.square .table-surface {
  width: 100px;
  height: 100px;
  border-radius: 12px;
}

.table-visual.rectangle .table-surface {
  width: 120px;
  height: 80px;
  border-radius: 12px;
}

.table-visual.rectangle-large .table-surface {
  width: 140px;
  height: 90px;
  border-radius: 12px;
}

.table-number {
  font-size: 1.5rem;
  font-weight: 800;
  color: white;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.table-capacity {
  font-size: 0.75rem;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 600;
}

.chair {
  position: absolute;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 0;
  transition: all 0.3s;
}

.chair-icon {
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, #64748b 0%, #475569 100%);
  border-radius: 8px 8px 2px 2px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  position: relative;
}

.chair-icon::before {
  content: '';
  position: absolute;
  top: -8px;
  left: 50%;
  transform: translateX(-50%);
  width: 28px;
  height: 16px;
  background: linear-gradient(135deg, #64748b 0%, #475569 100%);
  border-radius: 8px 8px 0 0;
}

.table-container.status-available .chair-icon {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
}

.table-container.status-available .chair-icon::before {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
}

.table-container.status-occupied .chair-icon {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
}

.table-container.status-occupied .chair-icon::before {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
}

.table-container.status-reserved .chair-icon {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
}

.table-container.status-reserved .chair-icon::before {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
}

.status-badge {
  padding: 0.5rem 1.25rem;
  border-radius: 2rem;
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.status-badge.available {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
}

.status-badge.occupied {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  color: white;
}

.status-badge.reserved {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
  color: white;
}

.table-container:hover .table-surface {
  transform: scale(1.05);
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.2);
}

.table-container:hover .chair-icon {
  transform: scale(1.1);
}

@media (max-width: 1024px) {
  .table-view {
    padding: 1rem;
    padding-top: 5rem;
  }

  .tables-grid {
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
    gap: 2.5rem;
    padding: 1rem;
  }

  .table-visual {
    width: 180px;
    height: 180px;
  }

  .table-visual.round .table-surface {
    width: 80px;
    height: 80px;
  }

  .table-visual.square .table-surface {
    width: 90px;
    height: 90px;
  }

  .table-visual.rectangle .table-surface {
    width: 110px;
    height: 70px;
  }

  .table-visual.rectangle-large .table-surface {
    width: 120px;
    height: 80px;
  }

  .table-number {
    font-size: 1.25rem;
  }

  .table-capacity {
    font-size: 0.625rem;
  }

  .chair {
    width: 28px;
    height: 28px;
  }

  .chair-icon {
    width: 28px;
    height: 28px;
  }

  .chair-icon::before {
    width: 24px;
    height: 14px;
  }
}

@media (max-width: 900px) {
  .tables-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 2rem;
  }
}

@media (max-width: 768px) {
  .table-view {
    padding: 0.75rem;
    padding-top: 5rem;
  }

  .tables-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 1.5rem;
    padding: 0.75rem;
  }

  .table-container {
    justify-self: center;
  }

  .table-visual {
    width: 150px;
    height: 150px;
  }

  .table-visual.round .table-surface {
    width: 70px;
    height: 70px;
  }

  .table-visual.square .table-surface {
    width: 80px;
    height: 80px;
  }

  .table-visual.rectangle .table-surface {
    width: 100px;
    height: 60px;
  }

  .table-visual.rectangle-large .table-surface {
    width: 110px;
    height: 70px;
  }

  .table-number {
    font-size: 1.125rem;
  }

  .table-capacity {
    font-size: 0.625rem;
  }

  .chair {
    width: 24px;
    height: 24px;
  }

  .chair-icon {
    width: 24px;
    height: 24px;
    border-radius: 6px 6px 2px 2px;
  }

  .chair-icon::before {
    top: -6px;
    width: 20px;
    height: 12px;
    border-radius: 6px 6px 0 0;
  }

  .status-badge {
    padding: 0.375rem 1rem;
    font-size: 0.625rem;
  }
}

@media (max-width: 480px) {
  .tables-grid {
    grid-template-columns: 1fr;
    gap: 1.25rem;
  }

  .table-container {
    justify-self: center;
  }

  .table-visual {
    width: 150px;
    height: 150px;
  }

  .table-visual.round .table-surface {
    width: 70px;
    height: 70px;
  }

  .table-visual.square .table-surface {
    width: 80px;
    height: 80px;
  }

  .table-visual.rectangle .table-surface {
    width: 100px;
    height: 60px;
  }

  .table-visual.rectangle-large .table-surface {
    width: 110px;
    height: 70px;
  }

  .table-number {
    font-size: 1.125rem;
  }

  .table-capacity {
    font-size: 0.625rem;
  }
}

@media (max-width: 380px) {
  .tables-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .table-visual {
    width: 140px;
    height: 140px;
  }

  .table-visual.round .table-surface {
    width: 65px;
    height: 65px;
  }

  .table-visual.square .table-surface {
    width: 75px;
    height: 75px;
  }

  .table-visual.rectangle .table-surface {
    width: 95px;
    height: 55px;
  }

  .table-visual.rectangle-large .table-surface {
    width: 105px;
    height: 65px;
  }

  .table-number {
    font-size: 1rem;
  }

  .table-capacity {
    font-size: 0.5rem;
  }
}
</style>
